import { Bot } from 'lucide-react';

const SIZES = {
  sm: { circle: 'h-7 w-7', icon: 'h-4 w-4' },
  md: { circle: 'h-9 w-9', icon: 'h-5 w-5' },
  lg: { circle: 'h-10 w-10', icon: 'h-6 w-6' },
} as const;

/**
 * Boris, the Business Partner: the Bot icon on a Trusted Blue circle, as in Chat with Boris and
 * the sidebar group. One definition so the request form and the chat cannot drift apart.
 */
export function BorisAvatar({ size = 'md' }: { size?: keyof typeof SIZES }) {
  return (
    <div className={`flex ${SIZES[size].circle} shrink-0 items-center justify-center rounded-full bg-trustedBlue text-white`}>
      <Bot className={SIZES[size].icon} aria-hidden="true" />
    </div>
  );
}
